import { render, staticRenderFns } from "./addVoice.vue?vue&type=template&id=57b12aa9&scoped=true&"
import script from "./addVoice.vue?vue&type=script&lang=js&"
export * from "./addVoice.vue?vue&type=script&lang=js&"
import style0 from "./addVoice.vue?vue&type=style&index=0&id=57b12aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b12aa9",
  null
  
)

export default component.exports